import {workflowStatus} from "@/util/workflow-statuses";
import cloneDeep from "lodash/cloneDeep";

const stopWorkflow = async ({ rootGetters, dispatch, commit }, data) => {
    try {
        commit('SET_RESUME_WORKFLOW_LOADING', true);

        const customer = rootGetters['customer/CUSTOMER'];
        const selected_customer = rootGetters['customer/SELECTED_CUSTOMER'];
        if(!data.customer_id) {
            data.customer_id = customer.customer_id;
            if (customer.customer_id === 0) {
                data.customer_id = selected_customer.customer_id;
            }
        }

        const response = await window.axios.post('/proxy/stop-workflow', data);
        if (response && response.data.success) {
            dispatch('notifications/pushNotification', `Workflow ${data === 'PAUSE' ? 'Paused' : 'Stopped'}`, {
                root: true,
            });
            if(data.onBreakpoint) {
                let running;
                if(data.workflow_id) {
                    running = cloneDeep(rootGetters['workflows/details/WORKFLOW_RUNNING_OBJ'](data.workflow_id));
                }
                running = {
                    ...running,
                    workflow_status: workflowStatus.CANCELLED,
                    workflowId: data.workflow_id
                };
                commit('workflows/details/SET_WORKFLOW_RUNNING_OBJ', running, { root: true });
            }
        } else {
            throw response.data;
        }
    } catch (error) {
        dispatch('notifications/setError', error.message, { root: true });
    } finally {
        commit('SET_RESUME_WORKFLOW_LOADING', false);
    }
};
export default stopWorkflow;
